

















































import { defineComponent } from '@nuxtjs/composition-api';
import BaseContentCategory from '@shared/components/@atoms/BaseContentCategory/BaseContentCategory.vue';
import Vue from 'vue';

import BaseContentPage from '../BaseContentPage/BaseContentPage.vue';
Vue.component('BaseContentPage', BaseContentPage);
Vue.component('BaseContentCategory', BaseContentCategory);
import BaseIcon from '@shared/components/@atoms/BaseIcon/BaseIcon.vue';
import BaseBar from '@shared/components/@molecules/BaseBar/BaseBar.vue';
import BaseMenuItem from '@shared/components/@molecules/BaseMenuItem/BaseMenuItem.vue';
import BaseList from '@shared/components/@organisms/BaseList/BaseList.vue';
import responsiveMixin from '@shared/ui/utilities/mixins/responsiveMixin';

export default defineComponent({
  name: 'BaseContentPages',
  components: {
    BaseList,
    BaseMenuItem,
    BaseIcon,
    BaseBar,
  },
  mixins: [responsiveMixin],
  provide() {
    const provided = {};
    Object.defineProperty(provided, 'active', {
      get: () => this.active,
    });
    return { provided };
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    active: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    categories() {
      // @ts-ignore migrated from ui-library
      const items = [];
      const orphans = { items: [] };
      const reduceOrphans = () => {
        if (orphans.items.length > 0) {
          const category = { ...orphans };
          items.push(category);
          orphans.items = [];
        }
      };
      this.items.forEach((item) => {
        // @ts-ignore migrated from ui-library
        if (item.items) {
          reduceOrphans();
          // @ts-ignore migrated from ui-library
          const category = { ...item };
          items.push(category);
          return;
        }
        orphans.items.push(item);
      });
      reduceOrphans();
      // @ts-ignore migrated from ui-library
      return items;
    },
    isActive(): any {
      // @ts-ignore migrated from ui-library
      return this.active.length > 0;
    },
  },
  watch: {
    isMobile(mobile) {
      if (mobile) {
        this.$emit('click:change', '');
        return;
      }
      this.$emit('click:change', this.categories[0].items[0].title);
    },
  },
  methods: {
    // @ts-ignore migrated from ui-library
    updatePage(title?: string) {
      this.$emit('click:change', title);
    },
    // @ts-ignore migrated from ui-library
    isPageActive(page) {
      return page.title.toLowerCase() === this.active.toLowerCase();
    },
  },
});
